


















































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import DefaultLayout from "@/components/layouts/DefaultLayout.vue";
import TDSButton from "@/components/common/TDSButton.vue";
import TableList from "@/components/partials/TableList.vue";
import Inputfield from "@/components/partials/Inputfield.vue";
import TDSModal from "@/components/partials/TDSModal/TDSModal.vue";
import PackageCard from "@/components/partials/PackageCard.vue";
import { Product } from "@/interfaces/entities/Product";
import { JoinerBonusInfo } from "@/interfaces/entities/JoinerBonusInfo";
import { emojiFlag } from "@/util/emojiFlag";
import ServerFilterPanel, { ActiveDataPackageFilters } from "@/components/partials/ServerFilterPanel.vue";
import Pagination from "@/components/partials/Pagination.vue";
import TDSSpinner from "@/components/common/TDSSpinner.vue";
import { coverageTypeOf } from "@/util/filterUtils";
import { tools } from "@/util/tools";

@Component({
    components: {
        ServerFilterPanel,
        Pagination,
        TDSModal,
        Inputfield,
        TableList,
        DefaultLayout,
        TDSButton,
        PackageCard,
        TDSSpinner
    }
})
export default class AddPackages extends Vue {
    private cartBoxIsOpen: boolean = false;
    private currentInventoryItems: Product[] = [];
    private inventoryItems: Product[] = [];
    // private bulkDiscount: BulkDiscount | null = null;
    // private bulkDiscountInfo: BulkDiscountInfo[] = [];
    private loadingInventoryPrice: boolean = false;
    private inventoryListenerName: string = "products-list-listener";
    private selectedAmounts: { [productId: string]: number } = {};
    private stepsCardVisible: boolean = false;
    private maxInventoryItemsScrollMobile: number = 160;
    // Desktop: cap the selection list so it scrolls inside the (sticky) panel instead of the page.
    private maxInventoryItemsScrollDesktop: number = 560;
    private inventorySearch: string = "";
    private showPackageModal: boolean = false;
    private showInventoryUpdatedModal: boolean = false;
    private modalPackage?: Product;
    private tableColumns: object = {
        coverage: { label: this.$t("tableHeader.dataPackage") as string, sortable: true, sortBy: (product: Product) => product.countrySet },
        sizeValue: {
            label: this.$t("tableHeader.volume") as string,
            sortable: true,
            width: "80px",
            align: "right",
            sortBy: tools.sortBySizeValue
        },
        validitySize: {
            label: this.$t("tableHeader.validity") as string,
            sortable: true,
            width: "100px",
            align: "right"
        },
        price: {
            label: this.$t("tableHeader.price") as string,
            sortable: true,
            width: "120px",
            align: "right",
            sortBy: (product: Product) => (product.prices ? product.prices[0].priceValue : 0)
        },
        detail: { label: "", sortable: false, width: "32px", align: "center" },
        add: { sortable: false, width: "140px", align: "center" }
    };
    private waitForHtmlElementsTimeout?: ReturnType<typeof setTimeout> = undefined;
    private showWelcomeBonus: boolean = false;
    private joinerBonusInfo: JoinerBonusInfo | null = null;
    private activeFilters: ActiveDataPackageFilters = {};
    private currentSortBy?: string = undefined;
    private currentSortDir?: string = undefined;
    private selectedPageSize: number = 50; // 0 = "All"
    private pageLoading: boolean = false;
    private showAllConfirm: boolean = false;
    private pageSizeOptions: Array<{ value: number; label: string }> = [
        { value: 25, label: "25" },
        { value: 50, label: "50" },
        { value: 100, label: "100" },
        { value: 200, label: "200" },
        { value: 0, label: "All" }
    ];
    private isLoading: boolean = true;
    private isUpdatingInventory: boolean = false;
    private selectedProductIds: { [key: string]: boolean } = {};

    get pagedProducts(): Array<Product> {
        return this.$store.state.pagedProducts;
    }

    get pageIndex(): number {
        return this.$store.state.pageIndex;
    }

    get pageSize(): number {
        return this.$store.state.pageSize;
    }

    get totalPageCount(): number {
        return this.$store.state.totalPageCount;
    }

    get filterOptions() {
        return this.$store.state.filterOptions;
    }

    get filtersLoading(): boolean {
        return this.$store.state.filtersLoading;
    }

    get hasActiveFilters(): boolean {
        const f = this.activeFilters;
        return !!(f.countrySets?.length || f.validityValues?.length || f.sizeValues?.length || f.includeUnlimited || f.packageCategories?.length);
    }

    get isMobile() {
        return this.$store.state.isMobile;
    }

    created() {
        document.title = process.env.VUE_APP_THEME_TITLE + " | " + this.$t("addPackages.pageTitle");
        this.fetchInventory();
        this.readSortFromRoute();
        this.fetchPage().finally(() => {
            this.isLoading = false;
        });
        this.$store.dispatch("FETCH_DATA_PACKAGE_FILTERS");
        this.$store.dispatch("FETCH_JOINER_BONUS_INFO").then((joinerBonusInfo: JoinerBonusInfo) => {
            this.joinerBonusInfo = joinerBonusInfo;
            this.showWelcomeBonus = joinerBonusInfo.showToUser;
        });
    }

    async fetchInventory() {
        this.inventoryItems = await this.$store.dispatch("FETCH_INVENTORY");
        if (this.currentInventoryItems.length === 0) this.currentInventoryItems = JSON.parse(JSON.stringify(this.inventoryItems));

        // Sync the selectedProductIds object
        this.inventoryItems.forEach((item: Product) => {
            if (item.productId) {
                this.$set(this.selectedProductIds, item.productId, true);
            }
        });
    }

    @Watch("pagedProducts")
    onPagedProductsChange(products: Array<Product>) {
        products.forEach((p: Product) => {
            if (!this.selectedAmounts[p.id]) {
                this.$set(this.selectedAmounts, p.id, 0);
            }
        });
    }

    // TableList persists sort in the URL query (sortKey/sortDir); react by refetching server-side.
    @Watch("$route.query")
    onRouteQueryChange() {
        this.readSortFromRoute();
        this.fetchPage(0);
    }

    @Watch("cartBoxIsOpen")
    cartBoxIsOpenChanged() {
        this.setCustomStyles();
    }

    @Watch("inventorySearch")
    inventorySearchChanged() {
        // Re-measure after the filtered list has rendered so the panel height matches it.
        this.$nextTick(() => this.setCustomStyles());
    }

    @Watch("showWelcomeBonus")
    showWelcomeBonusChanged() {
        this.updateInventoryBoxOpenState();
    }

    @Watch("isMobile")
    isMobileChanged() {
        if (this.showWelcomeBonus) this.cartBoxIsOpen = true;
        else this.cartBoxIsOpen = false;
    }

    @Watch("inventoryItems")
    itemsChanged() {
        console.log("[ProductsList] Inventory items changed: ", this.inventoryItems);
        this.updateInventoryBoxOpenState();
    }

    /** The selection list actually rendered: all packs, or (when searching) only matching ones. */
    get filteredInventoryItems(): Product[] {
        const query = this.inventorySearch.trim().toLowerCase();
        if (!query) return this.inventoryItems;
        return this.inventoryItems.filter((item: Product) => this.inventorySearchText(item).includes(query));
    }

    // Match against the same text the row shows: coverage (+ category) · volume · validity.
    private inventorySearchText(item: Product): string {
        const coverage = (this.$options.filters?.countryNameWithCategory(item) as string) || "";
        return `${coverage} ${this.getVolume(item)} ${item.validitySize} ${item.validityUnit}`.toLowerCase();
    }

    private getEmojiFlag(countryCode: string): string {
        return emojiFlag(countryCode, "🌏");
    }

    private coverageLabel(item: Product): string {
        switch (coverageTypeOf(item)) {
            case "worldwide":
                return "Worldwide";
            case "region":
                return "Region";
            default:
                return "Single country";
        }
    }

    private readSortFromRoute() {
        const sortKey = this.$route.query.sortKey as string | undefined;
        const sortDir = this.$route.query.sortDir as string | undefined;
        this.currentSortBy = sortKey ? this.mapSortKey(sortKey) : undefined;
        this.currentSortDir = sortDir || undefined;
    }

    private mapSortKey(columnKey: string): string | undefined {
        switch (columnKey) {
            case "coverage":
                return "coverage";
            case "sizeValue":
                return "volume";
            case "validitySize":
                return "validity";
            case "price":
                return "price";
            default:
                return undefined;
        }
    }

    private fetchPage(pageIndex: number = this.pageIndex) {
        this.pageLoading = true;
        return this.$store.dispatch("FETCH_DATA_PACKAGES_PAGE", {
            pageIndex,
            pageSize: this.selectedPageSize,
            // Default these views to coverage order (worldwide packs first).
            sortBy: this.currentSortBy ?? "coverage",
            sortDir: this.currentSortDir,
            ...this.activeFilters
        }).finally(() => {
            this.pageLoading = false;
        });
    }

    private onFilterChange(filters: ActiveDataPackageFilters) {
        this.activeFilters = filters;
        this.fetchPage(0);
    }

    private onPageChange(index: number) {
        this.fetchPage(index);
    }

    private onPageSizeChange(size: number) {
        // "All" loads the whole catalogue at once — confirm before applying.
        if (size === 0) {
            this.showAllConfirm = true;
            return;
        }
        this.selectedPageSize = size;
        this.fetchPage(0);
    }

    private confirmShowAll() {
        this.showAllConfirm = false;
        this.selectedPageSize = 0;
        this.fetchPage(0);
    }

    private cancelShowAll() {
        this.showAllConfirm = false;
    }

    public updateInventoryBoxOpenState() {
        if (this.showWelcomeBonus) this.cartBoxIsOpen = true;
        if (this.cartBoxIsOpen && (!this.inventoryItems || this.inventoryItems.length === 0)) {
            this.cartBoxIsOpen = false;
        } else if (!this.cartBoxIsOpen && this.inventoryItems && this.inventoryItems.length > 0) {
            this.cartBoxIsOpen = true;
        }
        this.setCustomStyles();
    }

    public isInInventory(item: Product): boolean {
        return !!this.selectedProductIds[item.id];
    }

    public addToInventoryFromModal(item: Product): void {
        this.addToInventory(item);
        this.closeDetailModal();
    }

    public addToInventory(item: Product): void {
        if (this.isInInventory(item)) return;
        item.productId = item.id;
        this.inventoryItems.push(item);
        this.$set(this.selectedProductIds, item.id, true);
    }

    public toggleItemInInventory(item: Product): void {
        if (this.isInInventory(item)) this.removeFromInventory(item.id);
        else this.addToInventory(item);
    }

    public removeFromInventory(productId: string): void {
        const itemToRemove = this.inventoryItems.findIndex((item: Product) => item.productId === productId);

        if (itemToRemove > -1) {
            this.inventoryItems.splice(itemToRemove, 1);
            this.$delete(this.selectedProductIds, productId);
        }
    }

    public async updateInventory() {
        if (this.isUpdatingInventory) return;
        this.isUpdatingInventory = true;
        try {
            const inventoryIds = this.inventoryItems.map((item: Product) => item.productId);
            const currentInventoryIds = this.currentInventoryItems.map((item: Product) => item.productId);
            const response = await this.$store.dispatch("UPDATE_INVENTORY", {
                addedPacks: inventoryIds.filter((item: string | undefined) => {
                    return !currentInventoryIds.includes(item);
                }),
                removedPacks: currentInventoryIds.filter((item: string | undefined) => {
                    return !inventoryIds.includes(item);
                })
            });
            await this.$router.push("/your-store/inventory");
        } catch (error) {
            console.error("Error updating inventory: ", error);
            this.$toastr.error("Failed to update inventory. Please review and try again.");
            /* { onClosed: () => 
                this.$router.push("/your-store/inventory")
            }); */
        } finally {
            this.isUpdatingInventory = false;
        }
    }

    public setCustomStyles() {
        console.log("[ProductsList] Set custom styles");
        const productCard = this.$refs.productCard as HTMLElement;
        const inventoryItems = this.$refs.inventoryItems as HTMLElement;
        if (this.waitForHtmlElementsTimeout) clearTimeout(this.waitForHtmlElementsTimeout);
        if (!inventoryItems || !productCard) {
            this.waitForHtmlElementsTimeout = setTimeout(() => {
                this.setCustomStyles();
            }, 500);
            return;
        }
        if (this.cartBoxIsOpen) {
            let extraHeight = 0;
            if (this.showWelcomeBonus) extraHeight += 80;
            const contentHeight = this.filteredInventoryItems.length * 64 + extraHeight;
            // Desktop caps the height (list scrolls internally); mobile keeps its own marginBottom logic.
            inventoryItems.style.height = (this.isMobile ? contentHeight : Math.min(contentHeight, this.maxInventoryItemsScrollDesktop)) + "px";
            if (inventoryItems.scrollHeight < this.maxInventoryItemsScrollMobile) {
                productCard.style.marginBottom = inventoryItems.scrollHeight + 140 + "px";
            } else {
                productCard.style.marginBottom = this.maxInventoryItemsScrollMobile + 140 + "px";
            }
        } else {
            inventoryItems.style.height = "0";
            productCard.style.marginBottom = "140px";
        }
        if (!this.isMobile) productCard.style.marginBottom = "inherit";
    }

    private openDetailModal(item: Product) {
        this.modalPackage = item;
        this.showPackageModal = true;
    }

    private closeDetailModal() {
        this.modalPackage = undefined;
        this.showPackageModal = false;
    }

    private changeSelectedAmount(productId: string, amount: number) {
        if (amount >= 0) {
            this.$set(this.selectedAmounts, productId, amount);
        }
    }

    private toggleInventoryBox() {
        if (this.inventoryItems.length === 0 && !this.showWelcomeBonus) return;
        this.cartBoxIsOpen = !this.cartBoxIsOpen;
    }

    private handleSelectAll(rows: Product[]): void {
        // Check if all items are selected
        const allSelected: boolean = rows.every((product: Product) => this.selectedProductIds[product.id]);

        if (!allSelected) {
            // Add only items that don't exist
            const newItems: Product[] = [];
            const newSelections: { [key: string]: boolean } = {};

            for (const product of rows) {
                if (!this.selectedProductIds[product.id]) {
                    const item = { ...product, productId: product.id };
                    newItems.push(item);
                    newSelections[product.id] = true;
                }
            }

            if (newItems.length > 0) {
                // Batch update: replace entire object in one operation
                this.selectedProductIds = { ...this.selectedProductIds, ...newSelections };
                this.inventoryItems = [...this.inventoryItems, ...newItems];
            }
        } else {
            // Remove all selected items
            const idsToRemove: Set<string> = new Set(rows.map((product: Product) => product.id));
            this.inventoryItems = this.inventoryItems.filter(
                (item: Product) => !idsToRemove.has(item?.productId || "")
            );

            // Batch update: create new object without removed IDs
            const newSelectedIds: { [key: string]: boolean } = {};
            for (const id in this.selectedProductIds) {
                if (!idsToRemove.has(id)) {
                    newSelectedIds[id] = true;
                }
            }
            this.selectedProductIds = newSelectedIds;
        }
    }

    // extra local method because vue can not access tools directly in template
    private getVolume(item: Product): string {
        return tools.getVolume(item);
    }
}
